import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export enum Roles {
    UNKNOWN = 'UNKNOWN',
    ADMIN = 'ADMIN',
    PROPERTY_OWNER = 'PROPERTY_OWNER',
    PROPERTY_TENANT = 'PROPERTY_TENANT',
    PROPERTY_TENANT_SHORT = 'PROPERTY_TENANT_SHORT',
    PROPERTY_COMPANY_ADMIN = 'PROPERTY_COMPANY_ADMIN',
    PROPERTY_COMPANY_AGENT = 'PROPERTY_COMPANY_AGENT',
    CLEANING_COMPANY_ADMIN = 'CLEANING_COMPANY_ADMIN',
    CLEANING_COMPANY_CLEANER = 'CLEANING_COMPANY_CLEANER',
};

export enum Permissions {
    CAN_CREATE_PERMISSIONS = 'CAN_CREATE_PERMISSIONS',
    CAN_CREATE_ROLES = 'CAN_CREATE_ROLES',
    CAN_SEE_ADMIN_COMPANY_USERS = 'CAN_SEE_ADMIN_COMPANY_USERS',
    CAN_INVITE_ADMIN_COMPANY_USERS = 'CAN_INVITE_ADMIN_COMPANY_USERS',
    CAN_HAVE_ADMIN_COMPANY = 'CAN_HAVE_ADMIN_COMPANY',
    CAN_CREATE_ADMIN_COMPANY = 'CAN_CREATE_ADMIN_COMPANY',
    CAN_SEND_EMAIL = 'CAN_SEND_EMAIL',
    CAN_SEE_USERS = 'CAN_SEE_USERS',
    CAN_SEE_COMPANIES = 'CAN_SEE_COMPANIES',
    CAN_UNKNOWN = 'CAN_UNKNOWN', //VIRTUAL ROLE TO BE USED WHEN NOT KNOWN AND WE WANT TO TRIGGER NOT ACCESS ERROR
    CAN_CHOOSE_ROLE = 'CAN_CHOOSE_ROLE',
    CAN_HAVE_PROPERTY_COMPANY = 'CAN_HAVE_PROPERTY_COMPANY',
    CAN_HAVE_CLEANING_COMPANY = 'CAN_HAVE_CLEANING_COMPANY',
    CAN_CREATE_PROPERTY_COMPANY = 'CAN_CREATE_PROPERTY_COMPANY',
    CAN_CREATE_CLEANING_COMPANY = 'CAN_CREATE_CLEANING_COMPANY',
    CAN_SEE_PROPERTY_COMPANY_AGENTS = 'CAN_SEE_PROPERTY_COMPANY_AGENTS',
    CAN_SEE_CLEANING_COMPANY_CLEANERS = 'CAN_SEE_CLEANING_COMPANY_CLEANERS',
    CAN_INVITE_PROPERTY_COMPANY_AGENTS = 'CAN_INVITE_PROPERTY_COMPANY_AGENTS',
    CAN_INVITE_CLEANING_COMPANY_CLEANERS = 'CAN_INVITE_CLEANING_COMPANY_CLEANERS',
    CAN_INVITE_PROPERTY_OWNERS = 'CAN_INVITE_PROPERTY_OWNERS',
    CAN_CREATE_PROPERTY = 'CAN_CREATE_PROPERTY',
    CAN_SEE_OWN_PROPERTIES = 'CAN_SEE_OWN_PROPERTIES',
    CAN_REQUEST_PROPERTY_COMPANY_MANAGEMENT = 'CAN_REQUEST_PROPERTY_COMPANY_MANAGEMENT',
    CAN_ACCEPT_PROPERTY_COMPANY_MANAGEMENT = 'CAN_ACCEPT_PROPERTY_COMPANY_MANAGEMENT',
    CAN_SEE_PROPERTY_COMPANIES = 'CAN_SEE_PROPERTY_COMPANIES',
    CAN_SEE_REQUEST_PROPERTY_COMPANY_MANAGEMENT = 'CAN_SEE_REQUEST_PROPERTY_COMPANY_MANAGEMENT',
    CAN_REQUEST_CLEANING_COMPANY_MANAGEMENT = 'CAN_REQUEST_CLEANING_COMPANY_MANAGEMENT',
    CAN_ACCEPT_CLEANING_COMPANY_MANAGEMENT = 'CAN_ACCEPT_CLEANING_COMPANY_MANAGEMENT',
    CAN_SEE_CLEANING_COMPANIES = 'CAN_SEE_CLEANING_COMPANIES',
    CAN_SEE_REQUEST_CLEANING_COMPANY_MANAGEMENT = 'CAN_SEE_REQUEST_CLEANING_COMPANY_MANAGEMENT',
    CAN_SEE_MANAGED_PROPERTIES = 'CAN_SEE_MANAGED_PROPERTIES',
    CAN_SEE_CLEANED_PROPERTIES = 'CAN_SEE_CLEANED_PROPERTIES',
    CAN_REQUEST_CLEANING = 'CAN_REQUEST_CLEANING',
    CAN_SEE_CLEANINGS = 'CAN_SEE_CLEANINGS',
    CAN_SEE_OWN_CLEANINGS = 'CAN_SEE_OWN_CLEANINGS',
    CAN_ASSIGN_CLEANINGS = 'CAN_ASSIGN_CLEANINGS',
    CAN_DO_CLEANINGS = 'CAN_DO_CLEANINGS',
    CAN_REQUEST_PAYMENT = 'CAN_REQUEST_PAYMENT',
    CAN_SEE_CUSTOMERS = 'CAN_SEE_CUSTOMERS',
    CAN_SEE_PAYMENTS = 'CAN_SEE_PAYMENTS',
    CAN_SEE_OWN_PROFILE = 'CAN_SEE_OWN_PROFILE',
    CAN_PAY = 'CAN_PAY',
    CAN_SEE_CALENDAR = 'CAN_SEE_CALENDAR',
    CAN_SEE_OWNER = 'CAN_SEE_OWNER',
    CAN_ADD_REVIEW = 'CAN_ADD_REVIEW',
    CAN_SEE_REVIEWS = 'CAN_SEE_REVIEWS',
    CAN_SEE_CLEANER = 'CAN_SEE_CLEANER',
    CAN_SEE_CHATS = 'CAN_SEE_CHATS',
    CAN_CREATE_CHAT = 'CAN_CREATE_CHAT',
    CAN_SEE_REQUESTER = 'CAN_SEE_REQUESTER',
    CAN_SEE_TENANT = 'CAN_SEE_TENANT',
    CAN_INVITE_PROPERTY_TENANTS = 'CAN_INVITE_PROPERTY_TENANTS',
    CAN_INVITE_PROPERTY_TENANTS_SHORT = 'CAN_INVITE_PROPERTY_TENANTS_SHORT',
    CAN_INVITE_PROPERTY_COOWNERS = 'CAN_INVITE_PROPERTY_COOWNERS',
    CAN_INVITE_PROPERTY_COMPANY_COADMINS = 'CAN_INVITE_PROPERTY_COMPANY_COADMINS',
    CAN_INVITE_CLEANING_COMPANY_COADMINS = 'CAN_INVITE_CLEANING_COMPANY_COADMINS',
    CAN_INVITE_PROPERTY_COMPANY_ADMINS = 'CAN_INVITE_PROPERTY_COMPANY_ADMINS',
    CAN_INVITE_CLEANING_COMPANY_ADMINS = 'CAN_INVITE_CLEANING_COMPANY_ADMINS',
    CAN_SEE_PROVIDERS = 'CAN_SEE_PROVIDERS',
    CAN_SEE_CALENDAR_RESERVATIONS = 'CAN_SEE_CALENDAR_RESERVATIONS',
    CAN_SEE_PROPERTY_PRIVATE_DETAILS = 'CAN_SEE_PROPERTY_PRIVATE_DETAILS',
    CAN_SEE_PROPERTY_MANAGEMENT_PRIVATE_DETAILS = 'CAN_SEE_PROPERTY_MANAGEMENT_PRIVATE_DETAILS',
    CAN_SEE_PROPERTY_CLEANING_PRIVATE_DETAILS = 'CAN_SEE_PROPERTY_CLEANING_PRIVATE_DETAILS',
    CAN_END_PROPERTY_TENANTS = 'CAN_END_PROPERTY_TENANTS',
};

@Injectable({
    providedIn: 'root',
})
export class RolesService {

	constructor(
		public apiService: ApiService,
	) {
	}

  createPermission(name: string, token: string) {

    var body: any;

    body = {name: name};

    return this.apiService.post('/permissions/create', body, token).pipe(response => response);

  }

  getPermissions(token: string) {

    var body: any;

    body = {};

    return this.apiService.get('/permissions/list', body, token).pipe(response => response);

  }

  getPermission(id: any, token: string) {

    var body: any;

    body = {id: id.toString()};

    return this.apiService.get('/permissions/read', body, token).pipe(response => response);

  }

  deletePermission(id: any, token: string) {

    var body: any;

    body = {id: id};

    return this.apiService.post('/permissions/delete', body, token).pipe(response => response);

  }

  createRole(name: string, invitation_only: boolean, token: string) {

    var body: any;

    body = {name: name, invitation_only: invitation_only};

    return this.apiService.post('/roles/create', body, token).pipe(response => response);

  }

  getRoles(token: string) {

    var body: any;

    body = {};

    return this.apiService.get('/roles/list', body, token).pipe(response => response);

  }

  getRole(id: any, token: string) {

    var body: any;

    body = {id: id.toString()};

    return this.apiService.get('/roles/read', body, token).pipe(response => response);

  }

  deleteRole(id: any, token: string) {

    var body: any;

    body = {id: id};

    return this.apiService.post('/roles/delete', body, token).pipe(response => response);

  }

  addRoleToPermission(role: string, permission: string, token: string) {

    var body: any;

    body = {role: role, permission: permission};

    return this.apiService.post('/roles/addRolePermission', body, token).pipe(response => response);

  }

  revokeRoleToPermission(role: string, permission: string, token: string) {

    var body: any;

    body = {role: role, permission: permission};

    return this.apiService.post('/roles/revokeRolePermission', body, token).pipe(response => response);

  }

}